import { toItemSku } from './itemSkuMapper.js'

/** @typedef {import('./itemSkuMapper.js').RawItemSku} RawItemSku */
/** @typedef {import('./itemSkuMapper.js').ItemSku} ItemSku */

/**
 * @typedef {Object} RawItem
 * @property {string} id
 * @property {string} name
 * @property {{imageUrl: string}} itemImage
 * @property {{name: string}} brand
 * @property {RawItemSku[]} itemSkus
 * @property {string[]|null} labels
 *
 * @typedef {Object} Item
 * @property {string} id
 * @property {string} name
 * @property {string} imageUrl
 * @property {string} brandName
 * @property {ItemSku[]} itemSkus 一覧表示対象のうち、経理情報があるSKU
 * @property {boolean} hasMultipleItemSkus
 * @property {boolean} soldOut
 * @property {string[]} labels
 */

/**
 * 商品レスポンスと一覧表示対象のSKUを正規化する。
 * @param {RawItem} item
 * @returns {Item}
 */
export const toItem = item => {
  const targetItemSkus = item.itemSkus.filter(
    sku => sku.itemSkuSalesCondition.display
  )
  const itemSkus = targetItemSkus
    .filter(sku => sku.itemSkuAccountingCondition != null)
    .map(toItemSku)

  return {
    id: item.id,
    name: item.name,
    imageUrl: item.itemImage.imageUrl,
    brandName: item.brand.name,
    itemSkus,
    hasMultipleItemSkus: targetItemSkus.length > 1,
    soldOut: targetItemSkus.every(sku => sku.itemSkuSalesCondition.soldOut),
    labels: item.labels || []
  }
}
